export function FullPageLoader({ message }: { readonly message?: string }) {
  return (
    <div className="nw-splash">
      <div className="nw-spinner" aria-hidden />
      <span>{message ?? 'Loading…'}</span>
    </div>
  );
}
